import { createContext, useState } from "react"
import API from "services/api"
import _ from "lodash"

export const PatentUploadContext = createContext({})

const PatentUploadProvider = (props) => {
	const [uploadLogs, setUploadLogs] = useState([])
	const [isLoading, setLoading] = useState(false)

	const getUploadLog = async (params) => {
		setLoading(true)
		try {
			let result = await API.getUploadLog(params)
			let data = result?.data
			setUploadLogs(data)
		} catch (error) {
			return error
		}
		setLoading(false)
	}

	const postUploadLogbyTask = async (sendData) => {
		let parentID = sendData?.parentID
		try {
			let result = await API.postUploadLogbyTask(sendData)
			await getUploadLog({ params: { parentID } })

			let data = result?.data

			return data
		} catch (error) {
			return error
		}
	}

	const postUploadLog = async (sendData) => {
		try {
			let result = await API.postUploadLog(sendData)
			let data = result?.data
			return data
		} catch (error) {
			return error
		}
	}

	const putUploadLog = async (id, sendData) => {
		try {
			let result = await API.putUploadLog(id, sendData)
			let data = result?.data
			return data
		} catch (error) {
			return error
		}
	}

	const deleteUploadLog = async (id) => {
		try {
			let result = await API.deleteUploadLog(id)
			let data = result?.data
			return data
		} catch (error) {
			return error
		}
	}

	return (
		<PatentUploadContext.Provider
			value={{
				uploadLogs,
				isLoading,

				getUploadLog,
				postUploadLog,
				postUploadLogbyTask,
				putUploadLog,
				deleteUploadLog
			}}
			{...props}
		/>
	)
}

export default PatentUploadProvider
